/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: announcementsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteAnnouncement } from './api/announcementApi';

/**
 * Shared helpers for Announcements module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an Announcement in the form.
 * Pattern: /pbx/incoming-tools/announcements/new?duplicate={id}
 */
export const getAnnouncementDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/announcements/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Announcement id.
 */
export const navigateToAnnouncementDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getAnnouncementDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an Announcement by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteAnnouncementById = async (id: string | number): Promise<void> => {
  await deleteAnnouncement(id);
};



